<template>
    <SfSection
        v-if="richText"
        layout="rich-text"
    >
        <div v-html="richText" class="article" /> <!-- eslint-disable-line -->
    </SfSection>
</template>

<script>
import { get } from 'lodash-es';
import contentBlockMixin from '~/mixins/content-block';
import SfSection from '~/patterns/organisms/section/section';

export default {
    components: {
        SfSection
    },

    mixins: [
        contentBlockMixin
    ],

    computed: {
        richText() {
            return get(this, 'block.wysiwyg', '');
        }
    }
};
</script>
